import { millisecondsInSecond } from 'date-fns/constants';
import jwtDecode from 'jwt-decode';

/**
 * Returns whether JWT is expired.
 *
 * Taken from https://github.com/keypuncherlabs/jwt-check-expiration/blob/master/src/index.js with added types.
 */
export const isJwtExpired = (token: string | undefined | null) => {
  if (typeof token !== 'string' || !token) throw new Error('Invalid token provided');

  const { exp } = jwtDecode<{ exp: number }>(token);
  const currentSeconds = new Date().getTime() / millisecondsInSecond;

  return currentSeconds > exp;
};
